import React from 'react';
import Box from '@mui/material/Box';
import InnSuggestForm from '../InnSuggestForm';
import { DadataLegalType } from '../../../enum/DadataLegalType';
import TaxationSystemForm from '../TaxationSystemForm';
import BankForm from '../Bank/BankForm';
import useAccount from '../../../hooks/useAccount';

const LegalProfileForm = () => {
  const { accountResponse } = useAccount();
  return (
    <div>
      <Box sx={{ mb: 5 }}>
        <h2>Данные организации</h2>
        <InnSuggestForm legalType={DadataLegalType.LEGAL} />
      </Box>
      <Box sx={{ mb: 5 }}>
        <h2>Система налогообложения</h2>
        <TaxationSystemForm />
      </Box>
      {accountResponse?.companyInn && (
        <Box sx={{ mb: 5 }}>
          <h2>Банковские реквизиты для перечисления вознаграждения</h2>
          <BankForm />
        </Box>
      )}
    </div>
  );
};

export default LegalProfileForm;
